import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import PersonalSearch from '../components/PersonalSearch'

const PersonalSearchPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <PersonalSearch />
            </div>
          </main>
    )
}

export default PersonalSearchPage